// extracted by mini-css-extract-plugin
export default {"desktop":"desktopView_desktop__FUA6l"};